import { getLocale } from "../runtime";

const da_warehousestaffwillpick = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vores lagerpersonale pakker dine varer så hurtigt som muligt i en miljøvenlig emballage.`
};

const en_warehousestaffwillpick = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Our warehouse staff will pack your items as quickly as possible in an environmentally friendly package.`
};

const es_warehousestaffwillpick = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Nuestro personal de almacén empaquetará tus artículos lo más rápido posible en un embalaje respetuoso con el medio ambiente.`
};

const fi_warehousestaffwillpick = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Varastohenkilökuntamme pakkaa tuotteesi mahdollisimman nopeasti ympäristöystävälliseen pakkaukseen.`
};

const nb_warehousestaffwillpick = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vårt lagerpersonell pakker varene dine så raskt som mulig i en miljøvennlig emballasje.`
};

const sv_warehousestaffwillpick = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vår lagerpersonal packar dina varor så snabbt de kan i ett miljövänligt paket.`
};

const warehousestaffwillpick = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_warehousestaffwillpick(inputs)
	if (locale === "en") return en_warehousestaffwillpick(inputs)
	if (locale === "es") return es_warehousestaffwillpick(inputs)
	if (locale === "fi") return fi_warehousestaffwillpick(inputs)
	if (locale === "nb") return nb_warehousestaffwillpick(inputs)
	if (locale === "sv") return sv_warehousestaffwillpick(inputs)
	return "warehouseStaffWillPick";
};

export { warehousestaffwillpick as "warehouseStaffWillPick" };